import { escape, unescape } from 'lodash';

export class Encoder {
    static encode(entry) {
        if (!entry) {
            return entry;
        }
        return encodeURIComponent(entry)
            .replace('!', '%21')
            .replace('\'', '%27')
            .replace('(', '%28')
            .replace(')', '%29')
            .replace('*', '%2A')
            .replace(';', '%3B')
            .replace('[', '%5B')
            .replace(']', '%5D');
    }

    static decode(entry) {
        if (!entry) {
            return entry;
        }
        return decodeURIComponent(entry)
            .replace('%21', '!')
            .replace('%27', '\'')
            .replace('%28', '(')
            .replace('%29', ')')
            .replace('%2A', '*')
            .replace('%3B', ';')
            .replace('%5B', '[')
            .replace('%5D', ']');
    }

    static escape(entry) {
        if (!entry) {
            return entry;
        }
        return escape(entry)
            .replace(/\n/g, '\\\\n')
            .replace(/\r/g, '\\\\r')
            .replace(/\t/g, '\\\\t');
    }

    static unescape(entry) {
        if (!entry) {
            return entry;
        }
        return unescape(entry)
            .replace('/\\\\n/g', '\n')
            .replace('/\\\\r/g', '\r')
            .replace('/\\\\t/g', '\t');
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/encoder.ts